import { EMPTY_OPTION_VALUE } from 'components/ApNiceSelect';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { useCallback } from 'react';

import {
  contractActionNameIdSet,
  contractActionSubstatusIdSet,
  contractActionTypeIdSet,
} from 'reducer/contractActionNameReducer';
import { useAppDispatch } from './reducerHooks';

export function useEditActionField(section: SectionType) {
  const dispatch = useAppDispatch();

  const editActionField = useCallback(
    (field: string, origValue: string) => {
      if (!origValue) return;
      let value: number | undefined = +origValue;
      if (origValue === EMPTY_OPTION_VALUE) {
        value = undefined;
      }
      if (section === SectionType.Contracts) {
        if (field === 'contractActionTypeId') {
          dispatch(contractActionTypeIdSet({ value }));
        } else if (field === 'contractActionSubStatusId') {
          dispatch(contractActionSubstatusIdSet({ value }));
        } else if (field === 'contractActionNameId') {
          dispatch(contractActionNameIdSet({ value }));
        }
      }
    },
    [dispatch, section],
  );

  const resetActionFields = useCallback(() => {
    if (section === SectionType.Contracts) {
      dispatch(contractActionTypeIdSet({ value: undefined }));
      dispatch(contractActionNameIdSet({ value: undefined }));
      dispatch(contractActionSubstatusIdSet({ value: undefined }));
    }
  }, [dispatch, section]);

  return {
    editActionField,
    resetActionFields,
  };
}
